import type { ReactNode } from 'react';
import { Badge } from 'components/badge';

import style from './badge-name.module.scss';

type Props = {
  children: ReactNode,
}

export const BadgeName = ({
  children,
}: Props) => (
  <Badge className={style.BadgeName}>
    {children}
  </Badge>
);
